import type { packsAsConst } from "@superego/boutique";
import type { TypeOf } from "@superego/schema";

type Security = TypeOf<(typeof packsAsConst)[2]["collections"][1]["schema"]>;

export default [
  {
    name: "SAP SE",
    ticker: "SAP",
    type: "Stock",
    currency: "EUR",
    exchange: "XETRA",
    sector: "Technology",
    isin: "DE0007164600",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 69.5 },
      { instant: "2017-03-17T12:00:00.000Z", price: 88.4 },
      { instant: "2018-03-16T12:00:00.000Z", price: 89.2 },
      { instant: "2019-03-15T12:00:00.000Z", price: 100.5 },
      { instant: "2020-03-13T12:00:00.000Z", price: 91.8 },
      { instant: "2021-03-19T12:00:00.000Z", price: 102.6 },
      { instant: "2022-03-18T12:00:00.000Z", price: 98.4 },
      { instant: "2023-03-17T12:00:00.000Z", price: 118.5 },
      { instant: "2024-03-15T12:00:00.000Z", price: 180.2 },
      { instant: "2025-03-14T12:00:00.000Z", price: 235.6 },
      { instant: "2026-03-06T12:00:00.000Z", price: 242.1 },
    ],
  },
  {
    name: "iShares Core MSCI World",
    ticker: "IWDA",
    type: "ETF",
    currency: "EUR",
    exchange: "Euronext",
    sector: "Global Equity",
    isin: "IE00B4L5Y983",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 35.8 },
      { instant: "2017-03-17T12:00:00.000Z", price: 41.2 },
      { instant: "2018-03-16T12:00:00.000Z", price: 44.8 },
      { instant: "2019-03-15T12:00:00.000Z", price: 47.6 },
      { instant: "2020-03-13T12:00:00.000Z", price: 38.5 },
      { instant: "2021-03-19T12:00:00.000Z", price: 60.2 },
      { instant: "2022-03-18T12:00:00.000Z", price: 67.4 },
      { instant: "2023-03-17T12:00:00.000Z", price: 68.8 },
      { instant: "2024-03-15T12:00:00.000Z", price: 82.5 },
      { instant: "2025-03-14T12:00:00.000Z", price: 90.4 },
      { instant: "2026-03-06T12:00:00.000Z", price: 93.2 },
    ],
  },
  {
    name: "Bitcoin",
    ticker: "BTC",
    type: "Crypto",
    currency: "EUR",
    exchange: null,
    sector: "Cryptocurrency",
    isin: null,
    priceHistory: [
      { instant: "2017-03-17T12:00:00.000Z", price: 940 },
      { instant: "2018-03-16T12:00:00.000Z", price: 6800 },
      { instant: "2019-03-15T12:00:00.000Z", price: 3500 },
      { instant: "2020-03-13T12:00:00.000Z", price: 4600 },
      { instant: "2021-03-19T12:00:00.000Z", price: 48500 },
      { instant: "2022-03-18T12:00:00.000Z", price: 36200 },
      { instant: "2023-03-17T12:00:00.000Z", price: 24800 },
      { instant: "2024-03-15T12:00:00.000Z", price: 62500 },
      { instant: "2025-03-14T12:00:00.000Z", price: 78300 },
      { instant: "2026-03-06T12:00:00.000Z", price: 83100 },
    ],
  },
  {
    name: "ASML Holding",
    ticker: "ASML",
    type: "Stock",
    currency: "EUR",
    exchange: "Euronext",
    sector: "Technology",
    isin: "NL0010273215",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 88.0 },
      { instant: "2017-03-17T12:00:00.000Z", price: 118.0 },
      { instant: "2018-03-16T12:00:00.000Z", price: 155.0 },
      { instant: "2019-03-15T12:00:00.000Z", price: 168.0 },
      { instant: "2020-03-13T12:00:00.000Z", price: 235.0 },
      { instant: "2021-03-19T12:00:00.000Z", price: 475.0 },
      { instant: "2022-03-18T12:00:00.000Z", price: 545.0 },
      { instant: "2023-03-17T12:00:00.000Z", price: 610.0 },
      { instant: "2024-03-15T12:00:00.000Z", price: 885.0 },
      { instant: "2025-03-14T12:00:00.000Z", price: 720.0 },
      { instant: "2026-03-06T12:00:00.000Z", price: 750.0 },
    ],
  },
  {
    name: "TotalEnergies SE",
    ticker: "TTE",
    type: "Stock",
    currency: "EUR",
    exchange: "Euronext",
    sector: "Energy",
    isin: "FR0000120271",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 39.8 },
      { instant: "2017-03-17T12:00:00.000Z", price: 47.5 },
      { instant: "2018-03-16T12:00:00.000Z", price: 44.2 },
      { instant: "2019-03-15T12:00:00.000Z", price: 49.8 },
      { instant: "2020-03-13T12:00:00.000Z", price: 28.5 },
      { instant: "2021-03-19T12:00:00.000Z", price: 38.6 },
      { instant: "2022-03-18T12:00:00.000Z", price: 47.2 },
      { instant: "2023-03-17T12:00:00.000Z", price: 54.8 },
      { instant: "2024-03-15T12:00:00.000Z", price: 62.4 },
      { instant: "2025-03-14T12:00:00.000Z", price: 58.9 },
      { instant: "2026-03-06T12:00:00.000Z", price: 56.2 },
    ],
  },
  {
    name: "Apple Inc.",
    ticker: "AAPL",
    type: "Stock",
    currency: "USD",
    exchange: "NASDAQ",
    sector: "Technology",
    isin: "US0378331005",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 26.0 },
      { instant: "2017-03-17T12:00:00.000Z", price: 36.0 },
      { instant: "2018-03-16T12:00:00.000Z", price: 42.5 },
      { instant: "2019-03-15T12:00:00.000Z", price: 47.5 },
      { instant: "2020-03-13T12:00:00.000Z", price: 57.0 },
      { instant: "2021-03-19T12:00:00.000Z", price: 122.0 },
      { instant: "2022-03-18T12:00:00.000Z", price: 155.0 },
      { instant: "2023-03-17T12:00:00.000Z", price: 148.0 },
      { instant: "2024-03-15T12:00:00.000Z", price: 172.0 },
      { instant: "2025-03-14T12:00:00.000Z", price: 228.0 },
      { instant: "2026-03-06T12:00:00.000Z", price: 235.0 },
    ],
  },
  {
    name: "Microsoft Corp.",
    ticker: "MSFT",
    type: "Stock",
    currency: "USD",
    exchange: "NASDAQ",
    sector: "Technology",
    isin: "US5949181045",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 52.0 },
      { instant: "2017-03-17T12:00:00.000Z", price: 65.0 },
      { instant: "2018-03-16T12:00:00.000Z", price: 92.0 },
      { instant: "2019-03-15T12:00:00.000Z", price: 115.0 },
      { instant: "2020-03-13T12:00:00.000Z", price: 149.0 },
      { instant: "2021-03-19T12:00:00.000Z", price: 235.0 },
      { instant: "2022-03-18T12:00:00.000Z", price: 295.0 },
      { instant: "2023-03-17T12:00:00.000Z", price: 280.0 },
      { instant: "2024-03-15T12:00:00.000Z", price: 410.0 },
      { instant: "2025-03-14T12:00:00.000Z", price: 430.0 },
      { instant: "2026-03-06T12:00:00.000Z", price: 445.0 },
    ],
  },
  {
    name: "NVIDIA Corp.",
    ticker: "NVDA",
    type: "Stock",
    currency: "USD",
    exchange: "NASDAQ",
    sector: "Technology",
    isin: "US67066G1040",
    priceHistory: [
      { instant: "2016-03-18T12:00:00.000Z", price: 0.8 },
      { instant: "2017-03-17T12:00:00.000Z", price: 2.7 },
      { instant: "2018-03-16T12:00:00.000Z", price: 6.0 },
      { instant: "2019-03-15T12:00:00.000Z", price: 4.05 },
      { instant: "2020-03-13T12:00:00.000Z", price: 5.25 },
      { instant: "2021-03-19T12:00:00.000Z", price: 13.0 },
      { instant: "2022-03-18T12:00:00.000Z", price: 6.8 },
      { instant: "2023-03-17T12:00:00.000Z", price: 27.5 },
      { instant: "2024-03-15T12:00:00.000Z", price: 88.0 },
      { instant: "2025-03-14T12:00:00.000Z", price: 120.0 },
      { instant: "2025-09-15T12:00:00.000Z", price: 135.0 },
      { instant: "2026-03-06T12:00:00.000Z", price: 125.0 },
    ],
  },
] satisfies Security[];
